import TableCellRenderer from '../../../../table/TableCellRenderer'
import ManageScopeCellContent from './ManageScopeCellContent'
import $ from 'jquery'
import {canUserAccessManagerScopes} from '../../utils'
import {ManagementAssignmentsSelection} from 'constants'

class ManageScopeCellRenderer extends TableCellRenderer {
    constructor({
                    editable,
                    onClick = () => {},
                    onMouseIn = () => {},
                    onMouseOut = () => {},
                    isURAEnabled = false,
                    isBTYEnabled = false,
                }) {
        super()

        this.params = {
            editable,
            onClick,
            onMouseIn,
            onMouseOut,
            isURAEnabled,
            isBTYEnabled,
        }
    }

    generateContent(cell) {
        this.content = new ManageScopeCellContent()
        this.content.init($(cell.getCellEl()))
        this.updateContent(cell)
    }

    updateContent(cell) {
        const {
            managementAssignmentsSelection,
            hasAssignedManagementScope,
            hasManageUsersRight
        } = cell.getValue()
        const hasManageScope = canUserAccessManagerScopes({
            userInfo: cell.getValue(),
            isURAEnabled: this.params.isURAEnabled,
            isBTYEnabled: this.params.isBTYEnabled,
        })

        this.content.setState({
            allScope: hasManageUsersRight || managementAssignmentsSelection === ManagementAssignmentsSelection.ALL,
            noAccess: managementAssignmentsSelection === ManagementAssignmentsSelection.NO,
            disabled: !hasManageScope,
            notAvailable: !this.params.editable,
            selectedScopeExists: hasAssignedManagementScope
        })

        $(cell.getCellEl())
            .on('click', (e) => this.params.onClick(cell, e))
            .hover(
                (e) => this.params.onMouseIn(cell, e),
                (e) => this.params.onMouseOut(cell, e)
            )
    }

    getCellClassName() {
        return ['manageScopeCell']
    }

    update({isURAEnabled, isBTYEnabled, hasManageScope}) {
        this.params.isURAEnabled = isURAEnabled
        this.params.isBTYEnabled = isBTYEnabled

        this.content.setState({disabled: !hasManageScope})
    }
}

export default ManageScopeCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/ManageScopeCellRenderer.js